import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { DashboardFeatureId } from '../../AdviserArea/AdviserArea.types';
import { LandingPage } from '../../ClientAccess/ClientAccess.types';
import { OnboardingWorkflow } from '../../CommonSelectors/CommonArea.types';
import { ModelGroupDTO } from '../../ClientAccess/api/useModelPortfolioGroupsQuery';

export interface OptionsDTO {
  label: string;
  value: number;
}

export interface ClientAccess {
  dashboardAccess: DashboardFeatureId[];
  onboardingWorkflow: OnboardingWorkflow;
  linkAccountsAccess: boolean;
  creditMonitoringAccess: boolean;
  dataReconciliationAccess: boolean;
  clientLandingPage: LandingPage | null;
  taxableAccountModelGroup: ModelGroupDTO | null;
  nonTaxableAccountModelGroup: ModelGroupDTO | null;
  fullyAutomatedAccountOpening: boolean;
  selectedAgreements: string[];
}

export interface CampaignDTO {
  id: string;
  name: string;
  isActive: boolean;
  clientAccess: ClientAccess;
  responses: number;
  firstEngagements: number;
  totalLeads: number;
  link: string;
  leadsAccess: number;
}

export interface CampaignsDTO {
  availableLeadsAccess: number[];
  campaigns: CampaignDTO[];
  clientLandingPageOptions: OptionsDTO[];
  defaultClientLandingPage: number;
  defaultLeadsAccess: number;
  hasBeFi20: boolean;
  onboardingWorkflowOptions: OptionsDTO[];
}

const fetchCampaigns = async (): Promise<CampaignsDTO> => {
  return authFetch('/Adviser/Campaigns');
};

export const useCampaignsQuery = () => {
  return useQuery(queryKeys.campaigns(), () => fetchCampaigns());
};
